// extracted by mini-css-extract-plugin
export default {"footer":"HelpPanel_footer__HWX49"};